module.exports = __webpack_public_path__ + "static/media/construction_service.bfd2a41b.svg";